module.exports = __webpack_public_path__ + "static/media/blogs_image.e84d2c00.svg";